import { render, staticRenderFns } from "./DetectionListDefaultLayout.vue?vue&type=template&id=01be4aae&scoped=true&"
import script from "./DetectionListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DetectionListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01be4aae",
  null
  
)

export default component.exports